import React from 'react';
import { Table } from 'antd';
import { PropTypes } from 'prop-types';
import ResizeableTitle from './resizableTitle/ResizableTitle';
import FhColumnSettingModal from '../fhColumnSettingModal/FhColumnSettingModal';
import CommContext from '../context/CommContext';
import './FhSimpleTable.less';

export default class FhSimpleTable extends React.Component {
  static contextType = CommContext;
  // 本地存储的列信息, 结构 { key: 列 key, { width: 列宽度 }}
  columnsInLocalStorage = {};
  // 本地存储的隐藏列KEy
  columnsSettingInLocalStorage = [];
  columnsHiddenInLocalStorage = [];
  // 保存标识，只有在被拖拽时保存
  needSave = false;

  rowSelectedEvent = null;

  // 排序MAP
  sortMap = {
    ascend: 'ASC',
    descend: 'DESC'
  };

  maxUpdateCount = 2;
  _isActive = true;
  constructor(props) {
    super(props);

    this.state = {
      updateCount: 0,
      selectedRowKeys: [],
      selectedRows: [],
      columns: [],
      initSettingColumns: []
    };
  }

  syncActiveState = () => {
    if (this.state.updateCount >= this.maxUpdateCount) {
      return; // 超过允许次数，不再更新key
    }
    const next = this.computeActive();
    if (next !== this._isActive) {
      this._isActive = next;
      if (next) {
        this.setState({
          updateCount: this.state.updateCount + 1
        });
      }
    }
  };

  // 工具方法：纯计算"激活态"是 true / false
  computeActive = () => {
    console.log('this.context 为空', this.context);
    if (!this.context) {
      return true;
    }
    const ctx = this.context || {};
    const { activeKey, tabKey } = ctx;
    return !(activeKey && tabKey && activeKey !== ctx.tabKey);
  };

  componentDidUpdate() {
    this.syncActiveState();
  }

  componentDidMount() {
    window.ref = this;
    this.syncActiveState();
    if (this.props.onRef) {
      this.props.onRef(this);
    }
    if (!this.props.orginColums) {
      this.initColumns(this.props.columns);
    }
    if (+sessionStorage.getItem('watermark') === 1) {
      const url = sessionStorage.getItem('url');
      if (url) {
        this.setWatermark(url);
      } else {
        const userName = sessionStorage.getItem('userName');
        let len = 0;
        for (var i = 0; i < userName.length; i++) {
          var a = userName.charAt(i);
          // 使用正则表达式区分全半角
          // eslint-disable-next-line no-control-regex
          if (a.match(/[^\x00-\xff]/ig) != null) {
            len += 2;
          } else {
            len += 1;
          }
        }
        if (len < 10) {
          len = 10;
        }
        this.createImgBase({
          width: (7 * len),
          height: (10 * len),
          content: userName,
          font: '26px sans-serif',
          color: '#aaaaaa',
          rotateDegree: 40,
          x: 20,
          y: 0
        });
      }
    }
  }

  /**
  * width: number;宽度
  * height: number; 高度
  * content: string; 水印内容
  * font: string; 水印字体
  * color: string; 水印颜色
  * rotateDegree: number; 偏转角度（deg）
  * x: number; X轴偏移量
  * y: number; Y轴偏移量
  * */
  createImgBase = (options) => {
    const canvas = document.createElement('canvas');
    const text = options.content;
    canvas.width = options.width * 2;
    canvas.height = options.height;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      // X轴阴影距离
      ctx.shadowOffsetX = 2;
      // Y轴阴影距离
      ctx.shadowOffsetY = 2;
      // 阴影的模糊程度
      ctx.shadowBlur = 2;
      ctx.font = options.font;
      ctx.fillStyle = options.color;
      ctx.rotate(options.rotateDegree * Math.PI / 180);
      ctx.textAlign = 'left';
      ctx.fillText(text, options.x, options.y);
      const url = canvas.toDataURL('image/png');
      sessionStorage.setItem('url', url);
      this.setWatermark(url);
    }
  }

  setWatermark=(url) => {
    const FhSimpleTableDoms = document.getElementsByClassName('FhSimpleTableDom');
    if (FhSimpleTableDoms && FhSimpleTableDoms.length) {
      for (const FhSimpleTableDom of FhSimpleTableDoms) {
        if (FhSimpleTableDom) {
          const antTableDom = FhSimpleTableDom.getElementsByClassName('ant-table')[0];
          if (antTableDom && !antTableDom.style.backgroundImage) {
            antTableDom.style.backgroundImage = 'url(' + url + ')';
          }
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.props.onRef) {
      this.props.onRef(null);
    }
    if (this.needSave && this.props.tableKey) {
      localStorage.setItem(this.props.tableKey, JSON.stringify(this.columnsInLocalStorage));
    }
  }

  initColumns(columns) {
    columns = this.initEditColumns(columns);
    this.setState({
      columns
    });
  }

  // 将列的顺序按照，本地缓存的顺序进行渲染
  // 参数oldList: 传入需要进行排序的list
  sortList = (oldList) => {
    const key = this.props.tableKey + '_columnSetting';
    const columnsList = [];
    if (key && JSON.parse(localStorage.getItem(key))) {
      JSON.parse(localStorage.getItem(key)).forEach(item => {
        const data = oldList.find(rItem => (rItem.key || null) === item);
        if (data) {
          columnsList.push(data);
        }
      });
    } else {
      columnsList.push(...oldList);
    }
    return columnsList;
  }

  // 实现 clearSort 方法
  clearSort() {
    this.setState(prevState => {
      const columns = prevState.columns.map(col => ({
        ...col,
        sortOrder: null // 清除排序状态
      }));
      return { columns };
    });
  }

  initEditColumns = (initcolumns) => {
    const { isCustomizeColumnWidth } = this.props;

    // 获取 localStorage 中保存的列
    if (this.props.tableKey) {
      this.columnsInLocalStorage = JSON.parse(localStorage.getItem(this.props.tableKey)) || {};
      this.columnsSettingInLocalStorage = JSON.parse(localStorage.getItem(this.props.tableKey + '_columnSetting')) || [];
      this.columnsHiddenInLocalStorage = JSON.parse(localStorage.getItem(this.props.tableKey + '_hiddenColSeting')) || [];
    }

    // 显示列与设置列的映射表
    const columnsVisable = [];
    const initcolumnsMap = new Map();
    const columnsVisableMap = new Map();
    const columnsVisableKey = [];
    // 剔除隐藏列 ==> 显示列
    initcolumns.forEach(colInfo => {
      const title = colInfo.titleNode || colInfo.title;
      const col = Object.assign({}, colInfo, {
        title: title
      });
      initcolumnsMap.set(col.key, col);
      if (!this.columnsHiddenInLocalStorage.includes(col.key)) {
        columnsVisable.push(col);
        columnsVisableKey.push(col.key);
        columnsVisableMap.set(col.key, col);
      }
    });

    let columns = [];
    const fixedRightColumns = [];
    //  排序 ==> columns
    if (this.columnsSettingInLocalStorage.length) {
      this.columnsSettingInLocalStorage.forEach(key => {
        const col = initcolumnsMap.get(key);
        if (col) {
          if (col.fixed === 'right') {
            fixedRightColumns.push(col);
          } else {
            columns.push(col);
          }
        } else {
          // console.log(key, 'simpleTable not key');
        }
      });
      // 排序结束后 可视列有剩余,添加到后面
      columnsVisableKey.forEach(itemKey => {
        if (!this.columnsHiddenInLocalStorage.includes(itemKey) && !this.columnsSettingInLocalStorage.includes(itemKey) && columnsVisableMap.get(itemKey)) {
          columns.push(columnsVisableMap.get(itemKey));
        }
      });
      columns.push(...fixedRightColumns);
    } else {
      columns = [...columnsVisable];
    }

    if (columns.length === 0) {
      columns.push({ title: '　' });
      return columns;
    }

    // 获取最后列定义
    const lastColumn = columns[columns.length - 1];

    if (lastColumn.title !== null && lastColumn.title !== undefined && lastColumn.title !== '　') {
      // 根据最后列是否为操作列、在最后添加空列
      if (lastColumn.title === '操作' || lastColumn.fixed === 'right') {
        columns.push({ title: '　', fixed: 'right' });
      } else {
        columns.push({ title: '　' });
      }
    }

    const maxIndex = columns.length - 1;

    columns = columns.map((col, index) => {
      const { width, ...restProps } = col;
      let colWidth = null;
      if (!this.columnsInLocalStorage[col.key]) {
        if (isCustomizeColumnWidth) {
          // 自定义宽度
          colWidth = width;
        } else {
          // 未设置宽度的统一设置为 100、最后列不设置宽度
          if (index < maxIndex) {
            if (width) {
              colWidth = width;
            } else {
              colWidth = 100;
            }
          }
        }

        this.columnsInLocalStorage[col.key] = { width: colWidth };
      } else {
        colWidth = this.columnsInLocalStorage[col.key].width;
      }

      return ({
        ...restProps,
        width: col.key === undefined ? null : colWidth,
        ellipsis: true,
        showSorterTooltip: false,
        onHeaderCell: column => ({
          headerClassName: column.headerClassName,
          width: column.width,
          onResize: this.handleResize(index)
        })
      });
    });
    return columns;
  }

  // 设置选择行
  setSelectRows = (rows = [], event, selectRow) => {
    const selectedRowKeys = rows.map(value => value.id);
    this.setState({
      selectedRowKeys,
      selectedRows: rows || []
    });

    this.props.onSelectedRows && this.props.onSelectedRows(rows, event, selectRow);
  }

  // 支持行选择
  onRowSelect = (selectRow, event) => {
    if (selectRow.customDisabled === '1') {
      // 不能选择的项点击行也不能勾选
      return;
    }
    if (this.props.getCheckboxPropsDisabled !== undefined) {
      if (this.props.getCheckboxPropsDisabled === 0) {
        return;
      }
    }
    // CheckBox 的时候存在多个
    var rows = null;
    if (this.props.rowSelectionType === 'checkbox') {
      rows = this.state.selectedRows;
      var keyIndex = -1;
      for (var i = 0; i < this.state.selectedRows.length; i++) {
        if (this.state.selectedRows[i].id === selectRow.id) {
          keyIndex = i;
          break;
        }
      }
      if (keyIndex > -1) {
        rows.splice(keyIndex, 1);
      } else {
        rows.push(selectRow);
      }

      // Radio 的时候只有一个
    } else if (this.props.rowSelectionType === 'notShow') {
      rows = null;
      return;
    } else {
      rows = [selectRow];
    }
    this.setSelectRows(rows, event.nativeEvent, selectRow);
  }

  // 单选事件（为了获取鼠标点击事件）
  onSelect = (record, selected, selectedRows, nativeEvent) => {
    this.rowSelectedEvent = nativeEvent;
  }

  // 单选事件
  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setSelectRows(selectedRows, this.rowSelectedEvent);
  };

  // 全选事件
  onSelectAll = (selected, selectedRows, changeRows) => {
    this.setSelectRows(selectedRows);
  }

  // 页面排序处理
  handleTableChange = (pagination, filters, sorter) => {
    this.props.onPageChange(
      sorter.order ? sorter.columnKey + ' ' + this.sortMap[sorter.order] : '',
      pagination.current,
      pagination.pageSize
    );

    this.setState(prevState => {
      const columns = prevState.columns.map(col => {
        if (col.key === sorter.columnKey) {
          return {
            ...col,
            sortOrder: sorter.order || null
          };
        } else {
          return {
            ...col,
            sortOrder: null
          };
  }
      });

      return { columns };
    });
  }

  // 列拖拽时
  // 重新设置列宽
  handleResize = index => (e, { size }) => {
    if (size.width !== this.state.columns[index].width) {
      this.needSave = true;
      const nextColumns = [...this.state.columns];
      nextColumns[index] = {
        ...nextColumns[index],
        width: size.width
      };

      this.columnsInLocalStorage[nextColumns[index].key] = { width: size.width };

      this.setState({
        columns: nextColumns
      });
    }
  };

  // 从localStorage恢复显示列初始化
  initColumnsFromSetting = (initSettingColumns) => {
    const colDefs = initSettingColumns && initSettingColumns.length > 0 ? initSettingColumns : this.props.columns;
    this.initColumns(colDefs);
  }

  // 打开列设置弹出框
  showColumnSettingModal = () => {
    this.columnSettingModalRef.editColumnSetting();
  }

  components = {
    header: {
      cell: ResizeableTitle
    }
  };

  render() {
    const {
      height, isLoading, rowSelectionType, pagination, rowSelection, tableRowClass, rowClassName, renderCell, indexColWidth, footer,
      hideSelectAll, current, total, defaultCurrent, defaultPageSize, preserveSelectedRowKeys, className, ...rest
    } = this.props;
    const { selectedRows } = this.state;
    const watermarkFlag = +sessionStorage.getItem('watermark');
    const key = `${this.props.tableKey}-${this.state.updateCount}`;
    return (
      <React.Fragment>
        <Table
          {...rest}
          key={key}
          className={(watermarkFlag === 1 ? 'FhSimpleTableDom SimpleTable ' : 'SimpleTable ') + (className || '')}
          bordered
          tableLayout='fixed'
          rowClassName={tableRowClass || rowClassName}
          size='small'
          onRow={(record) => ({
            onClick: (event) => (record.disableRowSelect ? null : this.onRowSelect(record, event))
          })}
          scroll={{ x: '100%', y: height }}
          rowKey={(record) => record.tsid ? record.tsid : record.id}
          components={this.components}
          columns={this.state.columns}
          onChange={this.handleTableChange}
          loading={isLoading}
          rowSelection={
            rowSelectionType === 'notShow' ? null : {
              columnWidth: indexColWidth === undefined ? 50 : indexColWidth,
              type: (rowSelectionType == null || rowSelectionType === 'radio') ? 'radio' : 'checkbox',
              selectedRowKeys: this.state.selectedRowKeys,
              renderCell: (text, record, index, originNode) => { return renderCell ? renderCell(text, record, index, originNode) : originNode; },
              onSelect: this.onSelect,
              onChange: this.onSelectChange,
              onSelectAll: this.onSelectAll,
              getCheckboxProps: rowSelection && rowSelection.getCheckboxProps,
              hideSelectAll: hideSelectAll === true,
              preserveSelectedRowKeys: preserveSelectedRowKeys || false
            }
          }
          pagination={pagination ? {
            current: current,
            total: total || 1,
            defaultPageSize: defaultPageSize || 10,
            defaultCurrent: defaultCurrent || 1,
            showTotal: (total, range) => <>
              <div className='dataInfoShow'>
                {rowSelectionType === 'checkbox' && <>
                  <div>
                已选【{selectedRows?.length || 0}】条
                </div>
                <div>
                  {this.props.dataInfoShow}
              </div>
                </>}
              </div>
              <div className='totalShow'>
                {this.props.total === 0 ? '共0条' : `第${range[0]}到${range[1]}条，共${total}条`}
              </div>
            </>,
            showLessItems: total !== 0,
            showQuickJumper: total !== 0,
            showSizeChanger: total !== 0,
            pageSizeOptions: pagination.pageSizeOptions ? pagination.pageSizeOptions : ['10', '20', '50', '100', '300']
          } : false}
          footer={pagination ? null : footer ? () => <div>
            <div className='dataInfoShow'>
              {rowSelectionType === 'checkbox' && <>
                <div>
                已选【{selectedRows?.length || 0}】条
              </div>
              <div>
                {this.props.dataInfoShow}
            </div>
              </>}
            </div>
            <div className='totalShow'>
            </div>
          </div> : null}>

        </Table>

        {/** 列设置弹出框 */}
        {
          this.props.orginColums
            ? <FhColumnSettingModal onRef={ref => (this.columnSettingModalRef = ref)} orginColums={this.props.orginColums}
              tableKey={this.props.tableKey} onReload={this.props.onReload} onInit={this.initColumnsFromSetting} />
            : null
        }

      </React.Fragment>
    );
  }
}

// 属性值类型
FhSimpleTable.propTypes = {
  // 每个表格唯一key 格式为[tb_ + 文件名]、同一文件多个表格后面加数字来区分
  // 例如：tb_profileManagement、tb_profileManagement_01、tb_profileManagement_02
  tableKey: PropTypes.string,
  // 表格列定义
  columns: PropTypes.array.isRequired,
  // 查询结果
  dataSource: PropTypes.array.isRequired,
  // 查询条件变化所用函数（条件变化包括：分页、排序）
  onPageChange: PropTypes.func,
  // true：分页/false：无分页
  pagination: PropTypes.bool || PropTypes.object,
  // table行禁用情况下 复选框不能点
  getCheckboxPropsDisabled: PropTypes.number,
  // pagination为true时、设置查询结果总数量
  total: PropTypes.number,
  // pagination为true时、设置查询展示页
  current: PropTypes.number,
  // 默认初始页数
  defaultCurrent: PropTypes.number,
  // 默认初始条数
  defaultPageSize: PropTypes.number,
  // 是否显示加载中
  isLoading: PropTypes.bool,
  // table行属性
  rowSelection: PropTypes.object,
  hideSelectAll: PropTypes.bool,
  // 行选择类型（可选值：checkbox、radio）
  rowSelectionType: PropTypes.string,
  // 类名
  className: PropTypes.string,
  // 选中行函数 Function(selectedRows) 当前选择的列
  onSelectedRows: PropTypes.func,
  // 获取Table ref
  onRef: PropTypes.func,
  // 是否自定义列宽
  isCustomizeColumnWidth: PropTypes.bool,
  // y轴高度
  height: PropTypes.node,
  // 底部自定义
  footer: PropTypes.bool,
  // 行样式设置
  rowClassName: PropTypes.func,
  tableRowClass: PropTypes.func,
  // 标题
  title: PropTypes.func,
  orginColums: PropTypes.array,
  onReload: PropTypes.func,
  // 多选情况下，可以记录分页选择的数据，如果不加点击多选框就会将之前选择的值清空
  preserveSelectedRowKeys: PropTypes.bool,
  // 复/单选选择框列宽度
  indexColWidth: PropTypes.number,
  // 底部展示数据
  dataInfoShow: PropTypes.node,
  // 复/单选单元元素(text, record, index, originNode)=> Element
  renderCell: PropTypes.func
};
